import { render, staticRenderFns } from "./CreateMany.vue?vue&type=template&id=a32a6642&scoped=true"
import script from "./CreateMany.vue?vue&type=script&lang=js"
export * from "./CreateMany.vue?vue&type=script&lang=js"
import style0 from "./CreateMany.vue?vue&type=style&index=0&id=a32a6642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32a6642",
  null
  
)

export default component.exports